export * from "./types.js";
export * from "./copy.js";
export {
  lostSuperLikelihood,
  multipleAccountFeeDrag,
  assertNoFundHandoff,
  FUND_HANDOFF_TOKENS,
} from "./calculate.js";
export { fy2024_25 } from "./fy2024-25.js";

import type { FinancialYear } from "../types.js";
import type { LostSuperRuleSet } from "./types.js";
import { fy2024_25 } from "./fy2024-25.js";

/** Registry of lost-super rulesets by ATO reporting year. Historical years stay
 * registered so re-runs resolve against the prize figures in force then. */
export const LOST_SUPER_RULESETS: Record<string, LostSuperRuleSet> = {
  "2024-25": fy2024_25,
};

/** Resolve the lost-super ruleset for a reporting year, or throw if unknown. */
export function lostSuperRulesFor(fy: FinancialYear): LostSuperRuleSet {
  const rules = LOST_SUPER_RULESETS[fy];
  if (!rules) {
    throw new Error(`no lost-super ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent lost-super ruleset — the default for live "this year" reads. */
export const LOST_SUPER_CURRENT_FY: FinancialYear = "2024-25";
